/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { globalVar } from "utils/globalVar";
import { combineURLPaths } from "utils/urlHelper";
import networkManager from "../network";
import { guardNetworkCall } from "../networkCallTypeguard";
import { PolicyList, LocalizedPolicyInformation } from "./models/policies";
import { LegalServiceDecodeError } from "./models/legal";

const { JUSTICE_API_URL: apiUrl } = globalVar;

export function fetchPoliciesByCountryCode(countryCode: string, defaultOnEmpty = true, policyType?: string) {
  const network = networkManager.create();

  return guardNetworkCall(
    () =>
      network.get(combineURLPaths(apiUrl, `agreement/public/policies/countries/${countryCode}`), {
        params: {
          defaultOnEmpty,
          policyType,
        },
      }),
    PolicyList,
    LegalServiceDecodeError,
    (error) => error
  );
}

export function fetchLocalizedPolicyInformation(localizedPolicyId: string) {
  const network = networkManager.create();
  return guardNetworkCall(
    () => network.get(combineURLPaths(apiUrl, `agreement/public/localized-policy-versions/${localizedPolicyId}`)),
    LocalizedPolicyInformation,
    LegalServiceDecodeError,
    (error) => error
  );
}
